<p>details-payment works!</p>
